import { useApi, createApiHook } from "../utils/apiUtils";

const useUploadExcelBulkQuestionnaires = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const uploadBulkExcel = async (file) => {
    if (!file) {
      return {
        data: null,
        errorMessage: { message: "No se proporcionó un archivo" },
      };
    }

    startLoading();

    const formData = new FormData();
    formData.append("file", file);

    const response = await apiPost("/questionnaires/bulk_create_from_excel", "Error al subir el archivo Excel de carga masiva", formData, {
      "Content-Type": "multipart/form-data",
    });

    setResponse(response);

    return {
      data: response?.data,
      status: response?.status,
      errorMessage: response?.error,
    };
  };

  return { uploadBulkExcel, data, error, loading };
};

export default useUploadExcelBulkQuestionnaires;
